import CopyTokenAddress from './CopyTokenAddress'

export default CopyTokenAddress
